import React from 'react';
import Label from "../../UI/Label";
import { arrowWidth, trackPropTypes, tracksWidth } from "../../../config/defaults";
import { getLabelColorByStateAndDifficulty, getTrackColorByStateAndDifficulty } from "../../../helpers/map";
import { TRACK_DIFFICULTY_BLUE, TRACK_DIFFICULTY_RED } from "../../../config/constants";
import TrackArrow from "../../UI/TrackArrow";

const Track14ABlue = ({ state, workState, onLabelClick }) => (
	<>
		<g id="Track14ABlue" transform="translate(1724.000000, 987.000000)" className="track">
			<g id="line" transform="translate(0.500000, 0.000000)"
				 stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE)} strokeLinecap="round"
				 strokeWidth={tracksWidth}
			>
				<path
					d="M573,206.75 L563.311587,191.344438 C559.889062,185.902276 552.702815,184.265037 547.260654,187.687561 C547.101137,187.787879 546.94408,187.892056 546.789622,188 L545.389297,188.978618 C545.389297,188.978618 545.389297,188.978618 545.389297,188.978618 C543.33512,190.414181 540.506126,189.912695 539.070562,187.858518 C537.778766,186.01006 538.040441,183.493432 539.684874,181.950262 L543.033867,178.807568 C544.242062,177.673799 544.302396,175.775263 543.168627,174.567068 C542.514492,173.869993 541.56731,173.52639 540.618386,173.641934 L443.048546,185.52232 L443.048546,185.52232"
					className="connector"/>
				<line x1="475.5" y1="197.291045" x2="366.126285" y2="157.983744"/>
				<TrackArrow transform="translate(368.976556, 159.315960) rotate(22.000000) translate(-368.976556, -159.315960) "
										points="372.976556 167.31596 364.976556 159.31596 372.976556 151.31596"/>
				<line x1="272.5" y1="118" x2="163" y2="71"/>
				<line x1="163" y1="71" x2="0.5" y2="0"/>
				<line x1="356" y1="153" x2="272.5" y2="118"/>
			</g>

			<Label
				onClick={(event, ref) => onLabelClick(event, ref, 'Track14ABlue')}
				coords="217.000000, 81.000000"
				text="14A"
				textCoordsX="6.77294922"
				colors={getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE)}
			/>
		</g>

		<g id="Track14ABlueBridge" transform="translate(2200.000000, 1180.000000)"
			 stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_RED)} strokeLinecap="round"
			 strokeWidth={tracksWidth}
		>
			<path d="M100.395575,16.7960074 L42.654863,8.49569398 M28.3984409,7.07783301 L0.377626232,4.29104545"/>
			<TrackArrow transform="translate(44.270390, 8.825195) rotate(-352.000000) translate(-44.270390, -8.825195) "
									points="48.2703901 16.8251947 40.2703901 8.82519472 48.2703901 0.825194723"/>
		</g>
	</>
);

Track14ABlue.propTypes = trackPropTypes;

export default Track14ABlue;
